import styled, { css } from 'styled-components';

export const HeaderStyled = css`
  display: block;
  padding: 10px 5px 0px 5px;
  margin: 10px auto;
  border: none;
  outline: none;
  font-family: 'Open Sans', sans-serif !important;
`;

export const InputStyled = css`
  background-color: hsl(0, 0%, 98%);
  border: 1px solid hsl(0, 0%, 80%);
  border-radius: 4px;
  box-sizing: border-box;
  display: block;
  font-size: 14px !important;
  font-family: 'Open Sans', sans-serif !important;
  margin: 10px auto;
  outline: none;
  padding: 10px;
  width: 100%;
  &:disabled {
    border-color: hsl(0, 0%, 90%);
    background: #f1f1f1;
  }
`;

export const Info = styled.div`
  padding: 5px;
  font-size: 10px;
  color: #666;
  background-color: #dedede;
`;

export const Warning = styled.div`
  padding: 5px;
  font-size: 10px;
  color: #9f6000;
  background-color: #feefb3;
`;

export const Columns = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;

  > div.column {
    box-sizing: border-box;
    margin-right: 15px;
    min-width: 150px;

    &.wide {
      flex-grow: 1;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;
